<template>
    <div class="card detail">
        <b-modal :active.sync="rejectModal" width="960px" has-modal-card>
            <reject-order-modal :order.sync="order" />
        </b-modal>

        <!-- Duplicate Modal -->
        <b-modal :active.sync="isDuplicate" trap-focus aria-role="dialog" aria-modal>
            <order-duplicate-modal :order="order" />
        </b-modal>

        <header class="card-header">
            <div class="card-header-title has-text-dark is-size-4">
                <p id="orderId">{{ order.orderId || order.id }}</p>
            </div>
            <div class="buttons">
                <b-button :loading="approving" v-if="order.status === 'PROPOSED' && canApproveProposedOrders"
                    @click="approve">APPROVE</b-button>
                <b-button :loading="rejecting" v-if="order.status === 'PROPOSED' && canApproveProposedOrders"
                    @click="reject">REJECT</b-button>
                <b-button id="reject_order" :loading="rejecting" :title="!canBeInDispute.value
                    ? canBeInDispute && canBeInDispute.help[0]
                    : ''
                    " @click="rejectModal = true" v-if="canBeInDispute &&
        canBeInDispute.value &&
        canBeInDisputeByUser &&
        canBeInDisputeByUser.value
        ">REJECT</b-button>
                <b-button id="approve_order" :loading="approving"
                    :title="!canBeBlap.value ? canBeBlap && canBeBlap.help[0] : ''" @click="approveBilling" v-if="canBeBlap &&
                        canBeBlap.value &&
                        canBeBlapByUser &&
                        canBeBlapByUser.value
                        ">APPROVE</b-button>
                <b-button id="claim_order" :loading="claiming"
                    :title="!canBeBlrq.value ? canBeBlrq && canBeBlrq.help[0] : ''" @click="claim" v-if="canBeBlrq &&
                        canBeBlrq.value &&
                        canBeBlrqByUser &&
                        canBeBlrqByUser.value
                        ">CLAIM</b-button>
                <b-button id="complete_order" @click="complete" :loading="completing" :title="!canBeCompleted.value
                    ? canBeCompleted && canBeCompleted.help[0]
                    : ''
                    " v-if="canBeCompleted &&
        canBeCompleted.value &&
        canBeCompletedByUser &&
        canBeCompletedByUser.value
        ">COMPLETE</b-button>

                <template v-if="HSFormType">
                    <b-button title="VIEW H&S AUDITS" type="is-text" @click="viewIncidents" v-if="(order.forms || []).length">
                        View H&S audits [{{ (order.forms).length }}]
                    </b-button>
                    <b-button title="LOG H&S AUDIT" @click="reportIncident">
                        <span class="icon"><i class="fa fa-list-alt fa-lg"></i></span>
                    </b-button>
                </template>

                <b-button :loading="cancelling" title="CANCEL ORDER" @click="cancel"
                    v-if="canBeCancelledBoolean && canBeCancelledByUserBoolean">
                    <span class="icon"><i class="fa fa-ban fa-lg"></i></span>
                </b-button>

                <b-button id="incorrectly_assigned_order"
                    :title="!canIncorrectlyAssignedBoolean ? canIncorrectlyAssignedHelp : 'Incorrectly Assigned'"
                    :disabled="!canIncorrectlyAssignedBoolean" :loading="incorrectlyAssigning" @click="incorrectlyAssign">
                    <b-icon icon="random" />
                </b-button>

                <b-button :title="!canCloseDuplicateBoolean ? canCloseDuplicateHelp : 'Report Duplicate Order'"
                    :disabled="!canCloseDuplicateBoolean" @click="isDuplicate = true">
                    <span class="icon"><i class="fa fa-subscript fa-lg"></i></span>
                </b-button>

                <button class="button" @click="
                    $router.push({
                        name: 'order-create',
                        params: { parentOrder: order }
                    })
                    " :disabled="!canIssueOrders"><span class="icon" title="ISSUE SUB-ORDER"><i
                            class="fa fa-copy fa-lg"></i></span></button>

                <b-button :id="canBeUnlocked && canBeUnlocked.value ? 'unlock_order' : 'lock_order'"
                    :type="canBeUnlocked && canBeUnlocked.value ? 'is-danger is-active' : ''" :loading="locking" :disabled="canBeUnlocked && canBeUnlocked.value
                        ? !canBeUnlockedByUser || !canBeUnlockedByUser.value
                        : !canBeLockedByUser || !canBeLockedByUser.value
                        " :title="canBeUnlocked && canBeUnlocked.value
        ? canBeUnlockedByUser && !canBeUnlockedByUser.value
            ? canBeUnlockedByUser && canBeUnlockedByUser.help[0]
            : ''
        : canBeLockedByUser && !canBeLockedByUser.value
            ? canBeLockedByUser && canBeLockedByUser.help[0]
            : ''
        " @click="toggleLock">
                    <b-icon :icon="canBeUnlocked && canBeUnlocked.value ? 'lock' : 'unlock'" />
                </b-button>

                <b-button :loading="printing" @click="print">
                    <span class="icon"><i class="fa fa-print fa-lg"></i></span>
                </b-button>

                <b-button type="button" :loading="integration_link_busy" :disabled="integration_link_busy"
                    @click.prevent="getAklcIntegrationLink(order.id)">
                    <span class="icon"><i class="fa fa-exchange fa-lg"></i></span>
                </b-button>

                <b-button :loading="starring" @click="starred ? unstar() : star()">
                    <b-icon :icon="`${starred ? 'star' : 'star-o'}`" />
                </b-button>

                <button class="button" @click="$emit('close')"><span class="icon"><i
                            class="fa fa-times-circle fa-lg"></i></span></button>

            </div>
        </header>
        <div class="card-content scrollable" style="padding:0">
            <order-detail-tabs :order.sync="order" :operations.sync="operations" @select="onSelect" ref="tabs"
                v-if="!reloading" />
        </div>
        <b-loading :is-full-page="false" :active.sync="reloading" :can-cancel="false"></b-loading>
    </div>
</template>

<script>
import OrderDetailTabs from "@/components/Order/OrderDetailTabs";
import { ConfigurationValidator } from "@/helpers/ConfigurationValidator";
import { OrderService } from "@/services/order.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { axiosCancelTokenMixin } from "@/mixins/axiosCancelTokenMixin";
import Roles from "@/helpers/roles";
import RejectOrderModal from "./RejectOrderModal";
import OrderDuplicateModal from "./OrderDuplicateModal";

export default {
    orderService: OrderService,
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    components: {
        OrderDetailTabs,
        RejectOrderModal,
        OrderDuplicateModal
    },
    mixins: [axiosCancelTokenMixin],
    data: () => ({
        operations: [],
        approving: false,
        rejecting: false,
        completing: false,
        claiming: false,
        printing: false,
        reloading: false,
        locking: false,
        integration_link_busy: false,
        incorrectlyAssigning: false,
        starring: false,
        // Used for cancelling getOrders() previous request
        cancelTokenSrc: null,
        rejectModal: false,
        isDuplicate: false,
        cancelling: false
    }),
    computed: {
        user() {
            return this.$store.state.Auth.user;
        },
        isSuperAdmin() {
            return this.$store.getters["Auth/hasRole"](Roles.SUPERADMIN);
        },
        canBeCompleted() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_completed"
            );
        },
        HSFormType() {
            const attribute = (this.order.createdByFirm && this.order.createdByFirm.attributes
                ? this.order.createdByFirm.attributes
                : []
            ).find(attribute => attribute.code === "FORM_TYPE_HS_1");

            return attribute && attribute.value ? attribute.value : "";
        },
        canBeCompletedByUser() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_completed_by_user"
            );
        },

        canIssueOrders() {
            return this.$store.getters["Auth/hasGivenContractPermission"]("contractee can create orders") || this.$store.getters["Auth/hasContractPermission"]("contractor can create orders");
            // return (
            //   this.$store.getters["Auth/hasFirmPermission"]("can issue orders")
            // );
        },

        canBeBlrq() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_blrq"
            );
        },
        canBeBlrqByUser() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_blrq_by_user"
            );
        },
        canBeBlap() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_blap"
            );
        },
        canBeBlapByUser() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_blap_by_user"
            );
        },
        canBeInDispute() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_in_dispute"
            );
        },
        canBeInDisputeByUser() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_in_dispute_by_user"
            );
        },
        canCloseDuplicateBoolean() {
            const can = this.$store.getters["OrderState/getStateByKey"](
                "can_be_closed_duplicate"
            );
            const canUser = this.$store.getters["OrderState/getStateByKey"](
                "can_be_closed_duplicate_by_user"
            );

            return can && can.value && canUser && canUser.value;
        },
        canCloseDuplicateHelp() {
            if (this.canCloseDuplicateBoolean) return "";

            const can = this.$store.getters["OrderState/getStateByKey"](
                "can_be_closed_duplicate"
            );
            const canUser = this.$store.getters["OrderState/getStateByKey"](
                "can_be_closed_duplicate_by_user"
            );

            return (
                (can && !can.value && can.help[0]) ||
                (canUser && !canUser.value && canUser.help[0])
            );
        },
        canBeLocked() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_locked"
            );
        },
        canBeLockedByUser() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_locked_by_user"
            );
        },
        canBeUnlocked() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_unlocked"
            );
        },
        canBeUnlockedByUser() {
            return this.$store.getters["OrderState/getStateByKey"](
                "can_be_unlocked_by_user"
            );
        },
        canApproveProposedOrders() {
            return this.$store.getters["Auth/hasPermission"](
                "can approve proposed orders"
            );
        },
        canReviewInvoices() {
            return this.$store.getters["Auth/hasPermission"](
                "can review invoices"
            );
        },
        canManageOrders() {
            return this.$store.getters["Auth/hasPermission"](
                "can review invoices"
            );
        },
        canIncorrectlyAssignedBoolean() {
            const can = this.$store.getters["OrderState/getStateByKey"](
                "can_be_incorrectly_assigned"
            );
            const canUser = this.$store.getters["OrderState/getStateByKey"](
                "can_be_incorrectly_assigned_by_user"
            );

            return can && can.value && canUser && canUser.value;
        },
        canIncorrectlyAssignedHelp() {
            if (this.canIncorrectlyAssignedBoolean) return "";

            const can = this.$store.getters["OrderState/getStateByKey"](
                "can_be_incorrectly_assigned"
            );
            const canUser = this.$store.getters["OrderState/getStateByKey"](
                "can_be_incorrectly_assigned_by_user"
            );

            return (
                (can && !can.value && can.help[0]) ||
                (canUser && !canUser.value && canUser.help[0])
            );
        },
        hasOrderOperationStatuses() {
            let statuses_ok = true;
            const operationStatus = ['BLRQ', 'FINALISED_NOBILLING', 'REJECTED', 'CLOSED_N'];
            this.operations.forEach(operation => {
                if (!operationStatus.includes(operation.status)) {
                    statuses_ok = false;
                }
            });
            return statuses_ok;
        },
        canCompleteByOperationCode() {
            let hasCode = [];
            if (this.operations.length > 0) {
                this.operations.forEach(operation => {

                    if (operation.outcomeCode && operation.responsibilityCode) {
                        hasCode.push(true);
                    } else if (operation.failureCode && operation.repairCode) {
                        hasCode.push(true);
                    } else {
                        hasCode.push(false);
                    }
                });
            }

            return hasCode.includes(false) ? false : true;
        },
        canClaim() {
            const statuses = ["COMPLETED"];

            const validators = ["must be allowed status"];
            const model = this.order;
            const params = {
                allowedStatuses: statuses
            };

            return ConfigurationValidator.validate(validators, model, params);
        },
        canApprove() {
            const statuses = ["BLRQ"];

            const validators = ["must be allowed status"];
            const model = this.order;
            const params = {
                allowedStatuses: statuses
            };

            return (
                this.order.createdByFirm &&
                this.user.firm.id === this.order.createdByFirm.id &&
                ConfigurationValidator.validate(validators, model, params)
            );
        },
        canReject() {
            const statuses = ["BLRQ"];

            const validators = ["must be allowed status"];
            const model = this.order;
            const params = {
                allowedStatuses: statuses
            };

            return (
                this.order.createdByFirm &&
                this.user.firm.id === this.order.createdByFirm.id &&
                ConfigurationValidator.validate(validators, model, params)
            );
        },
        canManageOperationsBoolean() {
            // Because it's a pain to keep checking (canManageOperations && canManageOperations.value)
            const obj = this.$store.getters["OrderState/getStateByKey"]("can_manage_operations");
            return obj && obj.value;
        },
        canSavePartialOrder() {
            return (
                this.canManageOperationsBoolean
                && !this.busySavingPartialOrder
            );
        },
        starred() {
            return (
                this.order.attributes &&
                !!this.order.attributes.find(
                    attribute =>
                        attribute.code == "[SYSTEM][ORDER][STARRED]" &&
                        attribute.createdBy == this.user.id
                )
            );
        },
        canBeCancelledBoolean() {
            const obj = this.$store.getters["OrderState/getStateByKey"](
                "can_be_cancelled"
            );
            return obj && obj.value;
        },
        canBeCancelledByUserBoolean() {
            const obj = this.$store.getters["OrderState/getStateByKey"](
                "can_be_cancelled_by_user"
            );
            return obj && obj.value;
        },
    },
    beforeDestroy() {
        this.actmCancelToken(this.cancelTokenSrc);
    },
    watch: {
        order: {
            handler: function (value, oldvalue) {
                if (!oldvalue || value.id != oldvalue.id) {
                    this.reloading = true;
                    this.$nextTick(() => {
                        this.getOrder();
                    });
                }
                // Reload tabs component
                // this.reloading = true;
                // this.$nextTick(() => {
                //   this.reloading = false;
                // });

                // Set order state
                this.$store.dispatch("OrderState/fetchState", this.order.id);
            },
            immediate: true
        }
    },
    methods: {
        async approve() {
            this.approving = true;

            try {
                const order = await this.$options.orderService
                    .approve(this.order.id)
                    .then(response => JsonDenormalizer.denormalize(response.data));

                this.order.status = order.status;

                this.order.billing_code = order.billing_code;

                this.$buefy.toast.open({
                    message: "Proposed order has been approved.",
                    type: "is-info",
                    position: "is-top-right"
                });
            } catch (err) { }

            this.approving = false;
        },
        async reject() {
            this.rejecting = true;

            try {
                const order = await this.$options.orderService
                    .reject(this.order.id)
                    .then(response => JsonDenormalizer.denormalize(response.data));

                this.order.status = order.status;

                this.$buefy.toast.open({
                    message: "Proposed order has been rejected.",
                    type: "is-info",
                    position: "is-top-right"
                });
            } catch (err) { }

            this.rejecting = false;
        },
        async complete() {
            this.completing = true;

            try {
                const order = await this.$options.orderService
                    .complete(this.order.id, { includes: "state" })
                    .then(response => JsonDenormalizer.denormalize(response.data));

                this.order.status = order.status;

                // Set order state
                this.$store.commit("OrderState/SET_STATE", order.state);

                this.$buefy.toast.open({
                    message: "Order has been completed.",
                    type: "is-info",
                    position: "is-top-right"
                });
            } catch (err) { }

            this.completing = false;
        },
        async claim() {
            this.claiming = true;

            try {
                const order = await this.$options.orderService
                    .claim(this.order.id, { includes: "state" })
                    .then(response => JsonDenormalizer.denormalize(response.data));

                this.order.status = order.status;

                // Set order state
                this.$store.commit("OrderState/SET_STATE", order.state);

                this.$buefy.toast.open({
                    message: "Order has been claimed.",
                    type: "is-info",
                    position: "is-top-right"
                });
            } catch (err) { }

            this.claiming = false;
        },
        async approveBilling() {
            this.approving = true;

            try {
                const order = await this.$options.orderService
                    .approveBilling(this.order.id, { includes: "state" })
                    .then(response => JsonDenormalizer.denormalize(response.data));

                this.order.status = order.status;

                // Set order state
                this.$store.commit("OrderState/SET_STATE", order.state);

                this.$buefy.toast.open({
                    message: "Order has been approved.",
                    type: "is-info",
                    position: "is-top-right"
                });

                this.$emit("approve-billing");
            } catch (err) { }

            this.approving = false;
        },
        async incorrectlyAssign() {
            this.incorrectlyAssigning = true;

            try {
                const order = await this.$options.orderService
                    .incorrectlyAssign(this.order.id, { includes: "state" })
                    .then(response => JsonDenormalizer.denormalize(response.data));

                this.order.status = order.status;

                // Set order state
                this.$store.commit("OrderState/SET_STATE", order.state);

                this.$buefy.toast.open({
                    message: "Order has been incorrectly assigned.",
                    type: "is-info",
                    position: "is-top-right"
                });
            } catch (err) { }

            this.incorrectlyAssigning = false;
        },
        async print() {

            this.printing = true;

            try {
                const mapImage = this.$refs.tabs.$refs.overview.$refs.orderMap
                    ? await this.$refs.tabs.$refs.overview.$refs.orderMap.takeScreenshot()
                    : null;

                const response = await this.$options.orderService.print(this.order.id, {
                    // template: 55671,
                    mapImage
                });

                const url = window.URL.createObjectURL(
                    new Blob([response], { type: "application/pdf" })
                );

                window.open(url);

                // const link = document.createElement("a");
                // link.href = url;
                // link.setAttribute("download", `Order ${this.order.orderId}.pdf`);
                // link.click();

            } catch (err) { }

            this.printing = false;

        },
        async toggleLock() {
            this.locking = true;

            const type = this.order.locked_at ? "unlock" : "lock";

            try {
                const order = await this.$options.orderService[type](
                    this.order.id
                ).then(response => JsonDenormalizer.denormalize(response.data));

                this.order.locked_at = order.locked_at;

                await this.$store.dispatch("OrderState/fetchState", this.order.id);

                this.$buefy.toast.open({
                    message: `Order has been ${type}ed.`,
                    type: "is-info",
                    position: "is-top-right"
                });
            } catch (err) { }

            this.locking = false;
        },
        onSelect(order) {
            this.$emit("select", order);
        },
        getAklcIntegrationLink(order_id) {
            const vm = this;
            vm.integration_link_busy = true;
            vm.$options.orderService.getAklcIntegrationLink(order_id)
                .then(response => {
                    const url = response.body.url;
                    window.open(url, '_blank');
                })
                .catch(err => { })
                .finally(() => {
                    vm.integration_link_busy = false;
                });
        },
        async getOrder() {
            try {
                this.cancelTokenSrc = this.actmGenerateToken(this.cancelTokenSrc);

                let includes = "problemCode,activityCode,kpiLogs,dateChangeLogs,firm,firm.permissions,firm.attributes,createdByFirm,createdByFirm.permissions,createdByFirm.attributes,claimLinesTotal,region,tags,orderTypeCode,orderSubtypeCode,attributes,ratings,ratings.createdBy,locationAsset,forms,contract"
                let order = await this.$options.orderService
                    .findOrderById(
                        this.order.id,
                        { includes: includes },
                        {
                            cancelToken: this.cancelTokenSrc.token
                        }
                    )
                    .then(response => JsonDenormalizer.denormalize(response));
                // this.$emit('update:order', order);
                this.$emit("fetched-relationships", order);
                this.reloading = false;
            } catch (err) { }
        },
        async star() {
            this.starring = true;

            try {
                const order = await this.$options.orderService
                    .star(this.order.id)
                    .then(response => JsonDenormalizer.denormalize(response.data));

                this.$buefy.toast.open({
                    message: "Order has been starred.",
                    type: "is-info",
                    position: "is-top-right"
                });

                this.$emit("fetched-relationships", order);
            } catch (err) { }

            this.starring = false;
        },
        async unstar() {
            this.starring = true;

            try {
                const order = await this.$options.orderService
                    .unstar(this.order.id)
                    .then(response => JsonDenormalizer.denormalize(response.data));

                this.$buefy.toast.open({
                    message: "Order has been un-starred.",
                    type: "is-info",
                    position: "is-top-right"
                });

                this.$emit("fetched-relationships", order);
            } catch (err) { }

            this.starring = false;
        },
        async cancel() {
            try {
                this.cancelling = true;

                await this.$options.orderService.cancel(this.order.id);

                this.$buefy.toast.open({
                    message: "Order has been cancelled.",
                    type: "is-info",
                    position: "is-top-right"
                });

                this.$emit("cancel");
            } catch (err) {
            } finally {
                this.cancelling = false;
            }
        },
        viewIncidents() {
            if (!this.HSFormType) return;
            let route = this.$router.resolve({
                name: "formio",
                query: {
                    "filter[form_type_code]": this.HSFormType,
                    "filter[model_type]": "order",
                    "filter[model_id]": this.order.id,
                },
            });
            window.open(route.href, "_blank");
        },
        reportIncident() {
            if (!this.HSFormType) return;
            let route = this.$router.resolve({
                name: "formio",
                query: {
                    form_type_code: this.HSFormType,
                    order_id: this.order.id,
                },
            });
            window.open(route.href, "_blank");
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Orders/list-new/partials/detail.vue